module.exports = __webpack_public_path__ + "static/media/aw6.d2d3d1da.png";